import { mutator } from 'satcheljs';
import * as mailListSelectionActionsV2 from 'owa-mail-actions/lib/mailListSelectionActions';
export default mutator(mailListSelectionActionsV2.resetSelectionOnTable, function (actionMessage) {
    var tableView = actionMessage.tableView;
    tableView.selectedRowKeys.clear();
    tableView.isInCheckedMode = false;
});
//# sourceMappingURL=resetSelectionOnTableMutator.js.map